module.exports = __webpack_public_path__ + "img/application_bg2.59dc3c51.jpg";